import * as React from "react";
import type { Viewport } from "src/types";

export interface IViewportContext {
  viewport: Viewport;
  setViewport: (viewport: Viewport) => void;
}

export const ViewportContext = React.createContext<IViewportContext>(
  {} as IViewportContext
);

type Props = {
  children: React.ReactNode;
};

export default function ViewportProvider(props: Props) {
  const [viewport, setViewport] = React.useState<Viewport>("desktop");

  return (
    <ViewportContext.Provider value={{ viewport, setViewport }}>
      {props.children}
    </ViewportContext.Provider>
  );
}
